import React from 'react';
import { styles } from '../../styles/theme';

const StatusBadge = ({ status }) => {
  const statusConfig = {
    active: { text: 'Ativo', style: styles.statusActive, emoji: '' },
    overdue: { text: 'Em Atraso', style: styles.statusOverdue, emoji: '' },
    completed: { text: 'Concluido', style: styles.statusCompleted, emoji: '' },
    pending: { text: 'Pendente', style: { backgroundColor: '#f85149', color: '#ffffff' }, emoji: '' },
    paid: { text: 'Pago', style: styles.statusActive, emoji: '' },
    sent: { text: 'Enviado', style: styles.statusActive, emoji: '' },
    scheduled: { text: 'Agendado', style: { backgroundColor: '#f85149', color: '#ffffff' }, emoji: '' },
    draft: { text: 'Rascunho', style: { backgroundColor: '#7d8590', color: '#ffffff' }, emoji: '' },
    cancelled: { text: 'Cancelado', style: { backgroundColor: '#484f58', color: '#ffffff' }, emoji: '' },
  };

  const config = statusConfig[status] || statusConfig.active;

  return (
    <span style={{ ...styles.statusBadge, ...config.style }}>
      {config.emoji} {config.text}
    </span>
  );
};

export default StatusBadge;
